export default [

     {
          path: '/asset-category',
          name: 'AssetCategory',
          component: () => import("@/views/Page/AssetCategory/AssetCategory.vue"),
           meta: {
               title: 'Asset Category',
          },
     }
];